import { UntypedFormControl } from '@angular/forms';
import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { RoomModel } from './room.model';

export class LocationModel extends BaseModel implements Deserializable {

  // columns
  name: any;
  virtual: boolean;
  other: boolean;
  country: string;
  timezone: string;
  pivot: any;
  room_count: number;

  // relations
  rooms: Array<RoomModel>;

  // client only
  control_value: UntypedFormControl = null; // tslint:disable-line: variable-name
  control_priority: UntypedFormControl = null; // tslint:disable-line: variable-name

  deserialize(input: any): this {
    Object.assign(this, input);
    // rooms
    let rooms = null;
    if (this.rooms !== null && this.rooms !== undefined) {
      rooms = [];
      this.rooms.forEach((room: RoomModel) => {
        rooms.push(new RoomModel().deserialize(room));
      });
    }
    this.rooms = rooms;
    return this;
  }

}
